import { twJoin } from 'tailwind-merge';

export const defaultInputClasses = twJoin(
  'ring-0 outline-0 transition-shadow duration-200',
  'focus-visible:outline-0 focus-visible:ring-2 focus-visible:ring-primary-600',
  'focus-visible:outline-transparent focus-visible:ring-offset-1',
  'disabled:opacity-50 disabled:cursor-not-allowed',
  'aria-disabled:opacity-50 aria-disabled:cursor-not-allowed',
);
